//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { DataProvider, TypeHelper } from '../../helpers'
import { Enums } from '../common'
import { ICopyable, IJsonSerializable, IOpChangeState, IReferenceType } from '../util/interfaces'

export class OpTaskTypeGroup
    implements IReferenceType, IOpChangeState, ICopyable<OpTaskTypeGroup>, IJsonSerializable {
    // #region Properties

    public idTaskTypeGroup: number
    public name: string
    public descr: string
    public idTaskTypeGroupParent: number
    public iLeft: number
    public iRight: number
    public rowVersion: any

    // #endregion

    // #region Naviagtion properties    

    // #endregion

    //#region Custom properties

    public dynamicValues: { Key: string, Value: any }[] = []

    //#endregion

    // #region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpTaskTypeGroup) {
            this.copy(<OpTaskTypeGroup>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion

    // #region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdTaskTypeGroup
    }

    public getReferenceKey(): number {
        return this.idTaskTypeGroup
    }

    public getReferenceValue(): any {
        return this
    }

    public toString(): string {
        return this.name
    }

    // #endregion

    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion

    // #region ICopyable implementation

    public copy(sourceObject: OpTaskTypeGroup, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {
        if (sourceObject == null) {
            return
        }

        if (includeNavigationProperties) {
            // no navigation properties
        }

        if (includeCustomProperties) {

        }

        if (includeDataList) {
            // No datalist
        }

        if (includeDynamicValues) {
            this.dynamicValues = TypeHelper.clone(sourceObject.dynamicValues, true)
        }

        this.idTaskTypeGroup = sourceObject.idTaskTypeGroup
        this.name = sourceObject.name
        this.descr = sourceObject.descr
        this.idTaskTypeGroupParent = sourceObject.idTaskTypeGroupParent
        this.iLeft = sourceObject.iLeft
        this.iRight = sourceObject.iRight
        this.rowVersion = sourceObject.rowVersion
    }

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): OpTaskTypeGroup {
        const result: OpTaskTypeGroup = new OpTaskTypeGroup(null)

        result.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return result
    }

    // #endregion

    // #region IJsonSerializable implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idTaskTypeGroup = opObj.ID_TASK_TYPE_GROUP
            this.idTaskTypeGroupParent = opObj.ID_TASK_TYPE_GROUP_PARENT
            this.name = opObj.NAME
            this.descr = opObj.DESCR
            this.iLeft = opObj.I_LEFT
            this.iRight = opObj.I_RIGHT

            this.dynamicValues = opObj.dynamicValues

            this.opState = opObj.OpState
        } else {
            this.idTaskTypeGroup = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_TASK_TYPE_GROUP: this.idTaskTypeGroup,
            ID_TASK_TYPE_GROUP_PARENT: this.idTaskTypeGroupParent,
            NAME: this.name,
            DESCR: this.descr,
            I_LEFT: this.iLeft,
            I_RIGHT: this.iRight,

            OpState: this.opState,
        }
    }

    // #endregion

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpTaskTypeGroup[]): JQueryPromise<OpTaskTypeGroup[]> {
        const defered: JQueryDeferred<OpTaskTypeGroup[]> = $.Deferred<OpTaskTypeGroup[]>()

        defered.resolve(list)

        return defered.promise()
    }
}